import React, { Fragment, useEffect, useState } from 'react';
import { UL, LI, Btn } from '../../../../AbstractElements';
import CartContext from '../../../../_helper/Ecommerce/Cart';
import { Input } from 'reactstrap';

const ColorSelector = ({ attributes, options, selectedColors, setSelectedColors, selectedRadio, setSelectedRadio, qty, setQty,
  api, selectedCheck, setSelectedCheck, selectedDropdownOptions, setSelectedDropdownOptions, }) => {

  const incrementQty = () => {
    if (api && qty < api.max_order) {
      setQty(prev => prev + 1);
    }
  };

  const decrementQuantity = () => {
    if (api && qty > api.min_order) {
      setQty(prev => prev - 1);
    }
  };


  const handleDropdownSelect = (title, val) => {
    setSelectedDropdownOptions((prev) => ({
      ...prev,
      [title]: val.id,
    }));

    options((prev) => {
      const filtered = prev.filter(opt => opt.title !== title);
      return [...filtered, { title, id: val.id, price: val.price, image: val.image }];
    });
  };


  const handleRadioSelect = (title, val) => {
    setSelectedRadio((prev) => ({
      ...prev,
      [title]: val.id,
    }));

    options((prev) => {
      const filtered = prev.filter(opt => opt.title !== title);
      return [...filtered, { title, id: val.id, price: val.price, image: val.image }];
    });
  };

  const handleCheckBox = (title, val) => {
    setSelectedCheck((prev) =>
      prev.includes(val.value)
        ? prev.filter((s) => s !== val.value)
        : [...prev, val.value]
    );

    options((prev) => {
      const exists = prev.find((item) => item.id === val.id && item.title === title);
      if (exists) {
        return prev.filter((item) => !(item.id === val.id && item.title === title));
      } else {
        return [...prev, { title, id: val.id, price: val.price }];
      }
    });
  };

  const handleColorSelect = (title, selectedItem) => {
    setSelectedColors((prev) => ({
      ...prev,
      [title]: selectedItem.label,
    }));

    options((prev) => {
      const filtered = prev.filter(opt => opt.title !== title);
      return [...filtered, { title, id: selectedItem.id, price: selectedItem.price, image: selectedItem.image }];
    });
  };

  return (
    <Fragment>
      {attributes?.color?.map((item, index) => (
        <div key={index} className="mb-3">
          <h5 className="mb-2"><b>{item.title}</b></h5>
          <UL attrUL={{ className: 'simple-list d-flex flex-row' }}>
            {item.value?.map((shade) => (
              <LI
                key={shade.id}
                attrLI={{
                  className: `rounded-1 mx-1 position-relative d-flex align-items-center justify-content-center`,
                  style: {
                    height: '30px',
                    width: '30px',
                    cursor: 'pointer',
                    backgroundColor: shade.label,
                    border: selectedColors[item.title] === shade.label ? '2px solid #000' : '1px solid #ccc',
                  },
                  onClick: () => handleColorSelect(item.title, shade),
                }}
              >
                {selectedColors[item.title] === shade.label && (
                  <i
                    className="fa fa-check"
                    style={{
                      color: '#fff',
                      fontSize: '16px',
                      textShadow: '0 0 2px rgba(0,0,0,0.5)',
                    }}
                  ></i>
                )}
              </LI>
            ))}
          </UL>
        </div>
      ))}
      {attributes?.radio?.map((item, index) => (
        <div key={index} className="mt-4">
          <h5 className="mb-2"><b>{item?.title}</b></h5>
          <div className="d-flex flex-wrap gap-2">
            {item?.value.map((val) => {
              const isSelected = selectedRadio[item.title] === val.id;
              return (
                <button
                  key={val.id}
                  type="button"
                  className={`btn ${isSelected ? 'btn-primary' : 'btn-outline-primary'} px-3 py-1`}
                  onClick={() => handleRadioSelect(item.title, val)}
                >
                  {val.value}
                </button>
              );
            })}
          </div>
        </div>
      ))}

      {attributes?.checkbox?.map((item, index) => (
        <div className="mt-4">
          <h5 className="mb-2"><b>{item?.title}</b></h5>
          <div className="d-flex flex-wrap gap-2">
            {item?.value.map((val, index) => {
              return (
                <button
                  key={index}
                  type="button"
                  style={{
                    padding: '8px 20px',
                    border: '2px solid #534686',
                    borderRadius: '5px',
                    backgroundColor: selectedCheck.includes(val.value) ? '#534686' : 'transparent',
                    color: selectedCheck.includes(val.value) ? '#fff' : '#534686',
                    fontWeight: '500',
                    cursor: 'pointer',
                  }}
                  onClick={() => handleCheckBox(val.value, val)}
                >
                  {val.value}
                </button>
              )
            })}
          </div>
        </div>
      ))}
      {attributes?.dropdown?.map((item, index) => (
        <div className="mt-4 mb-4" key={index}>
          <h5 className="mb-2"><b>{item?.title}</b></h5>
          <select
            className="form-select w-50"
            value={selectedDropdownOptions[item.title] || ''}
            onChange={(e) => {
              const selectedOption = e.target.options[e.target.selectedIndex];
              const val = JSON.parse(selectedOption.getAttribute('data-val'));
              handleDropdownSelect(item.title, val);
            }}
          >
            <option value="">-- Select --</option>
            {item?.value.map((val) => (
              <option key={val.id} value={val.id} data-val={JSON.stringify(val)}>
                {val.value}
              </option>
            ))}
          </select>
        </div>
      ))}
      <fieldset className="qnty-box">
        <div className="input-group bootstrap-touchspin">
          <span className="input-group-prepend">
            <Btn
              attrBtn={{
                color: 'primary',
                className: 'btn btn-primary btn-square bootstrap-touchspin-down',
                onClick: decrementQuantity,
                disabled: !api || qty === api.min_order,
              }}
            >
              <i className="fa fa-minus"></i>
            </Btn>
          </span>

          <Input
            type="text"
            name="quantity"
            value={qty}
            readOnly={true}
            style={{ textAlign: 'center' }}
            className="form-control input-number"
          />

          <span className="input-group-append">
            <Btn
              attrBtn={{
                color: 'primary',
                className: 'btn btn-primary btn-square bootstrap-touchspin-up',
                onClick: incrementQty,
                disabled: !api || qty === api.max_order,
              }}
            >
              <i className="fa fa-plus"></i>
            </Btn>
          </span>
        </div>
      </fieldset>
    </Fragment>
  )
}

export default ColorSelector